import React from 'react';
import clsx from 'clsx';
import { IconSizeType } from 'common/constants';
import { UserIconReact } from 'common/widgets/user-icon';
import { UserInfo as UserInfoType } from 'apps/lexicon/src/models/event-definition';
import { ExperimentStatus } from 'apps/experiments/src/components/common/status';
import { ExperimentStatus as ExperimentStatusEnum, StatisticallySignificant } from 'apps/experiments/src/types';
import styles from './cell-renderers.module.styl';
type UserInfoArgs = {
  user: UserInfoType;
};
type StatusArgs = {
  status: ExperimentStatusEnum;
  percent: number;
  variant?: string;
};
type NameArgs = {
  name: string;
  description?: string;
  isEmphasized?: boolean;
};
type StatsigChipArgs = {
  label: string;
  statsig: StatisticallySignificant;
};
export function UserInfo(_ref: UserInfoArgs) {
  let {
    user
  }: UserInfoArgs = _ref;
  const userIconAttrs = user !== null && user !== void 0 && user.id ? {
    id: user === null || user === void 0 ? void 0 : user.id,
    name: user === null || user === void 0 ? void 0 : user.name,
    email: user === null || user === void 0 ? void 0 : user.email
  } : {};
  return <div className={styles.userInfoField} data-sentry-component="UserInfo" data-sentry-source-file="cell-renderers.tsx">
      <UserIconReact size={IconSizeType.Small} {...userIconAttrs} data-sentry-element="UserIconReact" data-sentry-source-file="cell-renderers.tsx" />
    </div>;
}
export function Status(_ref2: StatusArgs) {
  let {
    status,
    percent,
    variant
  }: StatusArgs = _ref2;
  return <ExperimentStatus status={status} percent={percent} variant={variant} data-sentry-element="ExperimentStatus" data-sentry-component="Status" data-sentry-source-file="cell-renderers.tsx" />;
}
export function Name(_ref3: NameArgs) {
  let {
    name,
    description,
    isEmphasized
  }: NameArgs = _ref3;
  return <div className={clsx(styles.nameField, {
    [styles.emphasized]: isEmphasized
  })} data-sentry-component="Name" data-sentry-source-file="cell-renderers.tsx">
      <div className={styles.name}>{name}</div>
      {description && <div className={styles.description}>{description}</div>}
    </div>;
}
const STATSIG_PREFIX_MAP: Partial<Record<StatisticallySignificant, string>> = {
  [StatisticallySignificant.YES_POSITIVE]: "\u2191",
  [StatisticallySignificant.YES_NEGATIVE]: "\u2193"
};
export function StatsigChip(_ref4: StatsigChipArgs) {
  let {
    label,
    statsig
  }: StatsigChipArgs = _ref4;
  label = "".concat(STATSIG_PREFIX_MAP[statsig], " ").concat(label);
  return <div className={clsx(styles.chip, {
    [styles.significantPositive]: statsig === StatisticallySignificant.YES_POSITIVE,
    [styles.significantNegative]: statsig === StatisticallySignificant.YES_NEGATIVE
  })} title={label} data-sentry-component="StatsigChip" data-sentry-source-file="cell-renderers.tsx">
      {label}
    </div>;
}
export function StatsigChipWrapper(_ref5: {
  children: React.ReactNode;
}) {
  let {
    children
  }: {
    children: React.ReactNode;
  } = _ref5;
  return <div className={styles.chipWrapper} data-sentry-component="StatsigChipWrapper" data-sentry-source-file="cell-renderers.tsx">{children}</div>;
}